module.exports = __webpack_public_path__ + "media/background.490a7b42.mp3";